import { forwardRef, useCallback } from 'react';

import { useNavigate, useNavLinkState } from '@spazious/dollhouse-router';
import { styled } from '@spazious/dollhouse-theme';
import { NavButton, NavButtonProps } from '@spazious/dollhouse-uikit';

import { ROUTE_PATH_ROOT } from '../../constants/index.js';

export interface MenuNavButtonProps extends NavButtonProps {}

export const MenuNavButton = styled(
  forwardRef<HTMLButtonElement, MenuNavButtonProps>(({ onClick, ...restProps }, ref) => {
    const navigate = useNavigate();
    const { actived } = useNavLinkState(restProps);

    const handleClick = useCallback<PickProp<NavButtonProps, 'onClick'>>(
      (evt) => {
        onClick?.(evt);

        if (!evt.defaultPrevented && actived) {
          navigate(ROUTE_PATH_ROOT);
          evt.preventDefault();
        }
      },
      [actived, navigate, onClick]
    );

    return <NavButton ref={ref} {...restProps} onClick={handleClick} />;
  })
).withConfig({
  displayName: 'MenuNavButton',
})``;
